module.exports = __webpack_public_path__ + "static/media/NoValePortada.fbf570cf.png";